"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Total = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignSelf: 'initital',
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            flexGrow: 1,
            alignSelf: 'center',
            marginBottom: 0,
            maxWidth: '35%'
        }
    };
});
const Text = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        flexBasis: '70%',
        [theme.breakpoints.up('md')]: {
            flexBasis: '30%'
        }
    };
});
const Bp = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginLeft: 'auto',
        whiteSpace: 'nowrap',
        fontSize: theme.typography.caption.fontSize,
        fontWeight: 'normal',
        [theme.breakpoints.up('md')]: {
            fontSize: theme.typography.body1.fontSize
        }
    };
});
const Amount = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginLeft: theme.spacing(2),
        width: '33%',
        whiteSpace: 'nowrap',
        textAlign: 'right'
    };
});
const Total = (param)=>{
    let { 'data-testid': testId, totalAmountSelected, totalBp } = param;
    const totalSelectedNum = Number(totalAmountSelected);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Text, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "total"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Bp, {
                "data-testid": "".concat(testId, "-bp"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "bpCount",
                    values: {
                        0: totalBp
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Amount, {
                "data-testid": "".concat(testId, "-price"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                    children: Number.isNaN(totalSelectedNum) ? 0 : totalSelectedNum
                })
            })
        ]
    });
};
exports.Total = Total;
